<template>
  <div style="min-height: 240px;">
    <div class="chart-title">Entry Hours PL</div>
    <div class="settings-button">
      <miniSettings :position="position" :minis="minis" />
    </div>
    <apexchart
      ref="userWeek"
      class="mb-6"
      v-if="data"
      type="bar"
      height="200"
      :options="chartOptions"
      :series="series"
    ></apexchart>
    <div class="width-full float-left text-center text-grey no-trades" v-else>NO TRADES</div>
  </div>
</template>

<script>
import miniSettings from "./miniSettings";
export default {
  name: "MiniWeek",
  components: { miniSettings },
  props: ["data", "position", "minis"],

  watch: {
    data: function(val) {
      this.$refs.userWeek.updateSeries(
        [
          {
            data: val
          }
        ],
        true,
        true
      );
      this.updateColors();
    }
  },

  mounted() {
    this.updateColors();
  },
  methods: {
    updateColors() {
      this.chartOptions = {
        ...this.chartOptions,
        ...{
          plotOptions: {
            bar: {
              
              colors: {
                ranges: [
                  {
                    from: 0,
                    to: 999999,
                    color: "#79C04D"
                  },
                  {
                    from: -999999,
                    to: -1,
                    color: "#E62163"
                  }
                ]
              }
            }
          }
        }
      };
    }
  },
  data() {
    return {
      sorted: 0,
      miniType: { Strategies: "minichartsStrategy", Tags: "minichartsTag" },
      chartOptions: {
        dataLabels: {
              enabled: false
            },
        plotOptions: {
          bar: {
            //horizontal: true,
            
            columnWidth: "95%",
            distributed: false,
            colors: {
              ranges: [
                {
                  from: 0,
                  to: 999999,
                  color: "#79C04D"
                },
                {
                  from: -999999,
                  to: -1,
                  color: "#E62163"
                }
              ]
            }
          }
        },
        xaxis: {
          tickAmount: 24,
          labels: {
            show: true,
            style: {
              colors: "#808F9C",
              fontSize: "8px",
              fontFamily: "Roboto, Roboto Condensed Bold, sans-serif"
            }
          },
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          }
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          enabled: false
        },
        grid: {
          show: false
        },
        colors: [],
        chart: {
          toolbar: {
            show: false
          }
        },
        stroke: {
          show: false,
          curve: "smooth",
          lineCap: "butt",
          colors: undefined,
          width: 3,
          dashArray: 0
        }
      },
      series: [{ data: this.data }]
    };
  }
};
</script>

<style>
</style>